import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Text } from 'foundations-components/components/Text';
import { useAssignedTasks } from 'setup-guide-api/dataFetchingClient/queries/assignedTasks';
import { useAuth } from '../../hooks/auth';
import { jsx as _jsx } from "react/jsx-runtime";
export const TaskAssignmentBadge = ({
  taskId
}) => {
  const {
    user_id: userId
  } = useAuth().user;
  const {
    assignedOnboardingTasks
  } = useAssignedTasks();
  const assignedTask = assignedOnboardingTasks === null || assignedOnboardingTasks === void 0 ? void 0 : assignedOnboardingTasks.find(task => task.taskId === taskId);
  const isAssignedToMe = (assignedTask === null || assignedTask === void 0 ? void 0 : assignedTask.userId) === userId;
  if (!isAssignedToMe || !userId || !assignedTask) {
    return null;
  }
  return /*#__PURE__*/_jsx(Badge, {
    use: "calypso",
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-primary-on-fill-default",
      textAlign: "center",
      textTransform: "uppercase",
      textWrap: "nowrap",
      typography: "heading-25",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.taskAssignmentBadge.assigned"
      })
    })
  });
};